import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import withAddAlert from "../../../../../hocs/withAddAlert";
import config from "../../../../../config";
import { showAuthRecaptchaFailureAlert } from "../../../../../lib/auth/showAuthRecaptchaFailureAlert";

const InvisibleReCaptcha = forwardRef(({ addErrorAlert, ...props }, ref) => {
  const reCaptchaRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      async executeAsync() {
        if (typeof reCaptchaRef.current?.executeAsync !== "function") {
          console.error("Recaptcha has not been loaded");
          showAuthRecaptchaFailureAlert(addErrorAlert);
          return null;
        }

        try {
          const recaptcha = await reCaptchaRef.current.executeAsync();
          reCaptchaRef.current.reset();

          if (!recaptcha) {
            showAuthRecaptchaFailureAlert(addErrorAlert);
            return null;
          }

          return recaptcha;
        } catch (error) {
          console.error("Recaptcha verification failed", error);
          reCaptchaRef.current?.reset?.();
          showAuthRecaptchaFailureAlert(addErrorAlert);
          return null;
        }
      },
      reset() {
        reCaptchaRef.current?.reset?.();
      }
    }),
    [addErrorAlert]
  );

  return (
    <ReCAPTCHA
      {...props}
      badge={"bottomright"}
      sitekey={config.googleReCaptcha.sitekey}
      size={"invisible"}
      ref={reCaptchaRef}
    />
  );
});

InvisibleReCaptcha.displayName = "InvisibleReCaptcha";

export default withAddAlert(InvisibleReCaptcha);
